import styled from "styled-components";
import { Row } from "react-bootstrap";

export const Centered = styled.div`
  z-index: 1; /* Increase z-index for visibility */
  cursor: default;
  position: absolute;
`;

export const TheModal = styled.div`
  width: 100%;
  height: auto;
  background: #FAFAFA;
  color: white;
  z-index: 10;
  border-radius: 5px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
  overflow-y: auto;
`;

export const ModalContent = styled.div`
    // padding: 10px 20px;
    font-size: 16px;
    color: #2c3e50;
`;

export const ModalHeader = styled.div`
    background: #FAFAFA;
    overflow: hidden;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    display: flex;
    justify-content: center;
`;

export const CloseButton = styled.div`
    cursor: pointer;
    padding: 1px 4px;
    border-radius: 0px 5px 0px 0px;
    border: none;
    color: #2c3e50;
    background: white;
    transition: all 0.25s ease;
    position: absolute;
    right: 0;
    top: 0;
    align-self: flex-end;
    &:hover {
      background: #dfdfdf;
    }
`;

export const ActionRow = styled(Row)`
    padding: 10px 20px 10px 20px;
    width: 210px;
    cursor: pointer;
    &:hover {
      background: #efeded;
    }
`;

export const ConfirmDialogWrapper = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    padding: 20px;
    text-align: center;
    z-index: 102;

    .actions {
        margin-top: 10px;
        display: flex;
        justify-content: space-around;

        button {
            padding: 8px 12px;
            border: none;
            border-radius: 4px;
            cursor: pointer;
        }

        button:first-child {
            background-color: #d9534f;
            color: white;
        }

        button:last-child {
            background-color: #f0f0f0;
            color: #333;
        }
    }
`;